// extracted by mini-css-extract-plugin
export default {"errorMessage":"FormCollateral_errorMessage__9ZjvV","v2Link":"FormCollateral_v2Link__u6Sqo"};